/* eslint-disable id-length, @typescript-eslint/naming-convention  --
 * `t` is the standard i18next translation function name (id-length).
 * Conversation error keys intentionally mirror backend SCREAMING_SNAKE_CASE error codes (naming-convention).
 */
function getConversationErrorMessage(t) {
    const CONVERSATION_ERROR_MESSAGES = {
        // ChatErrorType messages - GENERATE_MESSAGE flow
        CHAT_NOT_ALLOWED_GENERATE_MESSAGE: t("error:conversation.chatNotAllowed.generateMessage"),
        TEMPLATE_LOADING_ERROR_GENERATE_MESSAGE: t("error:conversation.templateLoadingError.generateMessage"),
        INFERENCE_REQUEST_ERROR_GENERATE_MESSAGE: t("error:conversation.inferenceRequestError.generateMessage"),
        NO_RESPONSE_GENERATE_MESSAGE: t("error:conversation.noResponse.generateMessage"),
        // ChatErrorType messages - UPDATE_MESSAGE flow
        VIOLATES_GUIDELINE_UPDATE_MESSAGE: t("error:conversation.violatesGuideline.updateMessage"),
        MESSAGE_NOT_FOUND_UPDATE_MESSAGE: t("error:conversation.messageNotFound.updateMessage"),
        UPDATE_MESSAGE_NOT_ALLOWED_UPDATE_MESSAGE: t("error:conversation.updateMessageNotAllowed.updateMessage"),
        CONVERSATION_ID_MISSING_UPDATE_MESSAGE: t("error:conversation.conversationIdMissing.updateMessage"),
        // ChatErrorType messages - DELETE_MESSAGE_IMAGE flow
        MESSAGE_NOT_FOUND_DELETE_MESSAGE_IMAGE: t("error:conversation.messageNotFound.deleteMessageImage"),
        CONVERSATION_ID_MISSING_DELETE_MESSAGE_IMAGE: t("error:conversation.conversationIdMissing.deleteMessageImage"),
    };
    return CONVERSATION_ERROR_MESSAGES;
}
// eslint-disable-next-line import/prefer-default-export -- Named export preserves call sites and i18n static key extraction for `t("error:ΓÇª")`.
export { getConversationErrorMessage };
